var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFundingChallenges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,3.142c-7.732,0-14,6.268-14,14c0,7.732,6.268,14,14,14s14-6.268,14-14C46,9.41,39.732,3.142,32,3.142z M32,16.142 c2.757,0,5,2.243,5,5c0,2.414-1.721,4.434-4,4.899v2.101h-2v-2.101c-2.279-0.465-4-2.484-4-4.899h2c0,1.654,1.346,3,3,3s3-1.346,3-3 s-1.346-3-3-3c-2.757,0-5-2.243-5-5c0-2.414,1.721-4.434,4-4.899V6.142h2v2.101c2.279,0.465,4,2.484,4,4.899h-2c0-1.654-1.346-3-3-3 s-3,1.346-3,3S30.346,16.142,32,16.142z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 16.142,
    width: 4,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16.142,
    width: 4,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.728,
    y: 27.87,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -8.02 40.3806)",
    width: 2,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.272,
    y: 2.414,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 2.5233 14.9204)",
    width: 2,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.728,
    y: 3.414,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 9.9791 32.9202)",
    width: 4,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.272,
    y: 28.87,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -15.476 22.3733)",
    width: 4,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 33,
    width: 2,
    height: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 58,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 58,
    r: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,44.6L31,43v9h2v-9l1.2,1.6l1.6-1.2l-3-4c-0.377-0.504-1.223-0.504-1.6,0l-3,4L29.8,44.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.519,53.855c2.329-1.413,4.424-3.159,6.229-5.191c1.114-1.254,2.097-2.616,2.961-4.054l0.428,2.138l1.961-0.393l-1-5 c-0.058-0.291-0.243-0.542-0.504-0.683c-0.262-0.142-0.573-0.159-0.848-0.049l-5,2l0.743,1.857l2.591-1.037 c-0.819,1.383-1.759,2.69-2.827,3.892c-1.672,1.882-3.613,3.5-5.771,4.809L11.519,53.855z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.864,46.749l0.428-2.138c0.864,1.437,1.847,2.799,2.961,4.054c1.805,2.032,3.9,3.778,6.229,5.191l1.037-1.71 c-2.158-1.309-4.099-2.927-5.771-4.809c-1.068-1.202-2.008-2.509-2.827-3.892l2.591,1.037l0.743-1.857l-5-2 c-0.275-0.109-0.586-0.091-0.848,0.049c-0.261,0.142-0.446,0.392-0.504,0.683l-1,5L43.864,46.749z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingChallenges);
export default __webpack_public_path__ + "static/media/funding-challenges.9e223fb0135378c88c3e75b10b663776.svg";
export { ForwardRef as ReactComponent };